import { computed } from 'mobx';
import ApiModel     from './globals/ApiModel';

export default class ProviderModel extends ApiModel {
  static get path() {
    return '/backend/providers/{?id}';
  }

  @computed
  get providerName() {
    return this.get('name');
  }

  @computed
  get link() {
    return this.get('link');
  }

  @computed
  get email() {
    return this.get('email');
  }

  @computed
  get logoObjectUrl() {
    return this.get('logo.objectUrl');
  }

  @computed
  get counter() {
    return this.get('counter', 0);
  }
}
